module.exports = __webpack_public_path__ + "img/logo2.5d96ab7a.png";